import React from 'react';
import { Modal } from 'react-bootstrap';
import { PrivacyPolicyContent } from '../../views/extrapages/privacy-policy';
import { TermsOfUseContent } from '../../views/extrapages/terms-of-use';
import './static-page.css';

const DOCS = {
  terms: { title: 'Terms of Use', Content: TermsOfUseContent },
  privacy: { title: 'Privacy Policy', Content: PrivacyPolicyContent },
};

// Terms of Use / Privacy Policy in a modal, for places (like the signup
// consent line) where navigating to the full page would lose the user's
// progress. `doc` is 'terms' | 'privacy' | null (closed). Links inside the
// text open in a new tab for the same reason.
const LegalModal = ({ doc, onHide }) => {
  const entry = DOCS[doc];

  const openLinksInNewTab = (event) => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    event.preventDefault();
    window.open(anchor.href, '_blank', 'noopener,noreferrer');
  };

  return (
    <Modal show={Boolean(entry)} onHide={onHide} size="lg" centered scrollable className="nmsp-legal-modal">
      <Modal.Header closeButton>
        <Modal.Title>{entry?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body onClickCapture={openLinksInNewTab}>
        {entry && <entry.Content />}
      </Modal.Body>
    </Modal>
  );
};

export default LegalModal;
